import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Calificación de llamada", -1)
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "row m-0" }
const _hoisted_4 = { class: "d-flex pt-2 pb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Cancelar", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Guardar Cambios ")

import Modal from "@/components/Modal.vue";
import { Field } from "@/types/components";
import { Form } from "vee-validate";
import { generateDynamicSchema } from "@/store/schemas/client.schema";
import { computed, onMounted, ref } from "vue";
import useFormModal from "@/composables/FormModalComposable";
import { dynamicForm } from "@/util/consts";
import {
	TypificationModalModule,
	actionType,
} from "@/store/modules/TypificationModal";
import { AppModule } from "@/store/modules/app";

// => Data
type FormPayload = {
	[k: string]: any;
};

// props

export default /*#__PURE__*/_defineComponent({
  props: {
    open: { type: Boolean },
    dataKey: null
  },
  emits: ["changeModal"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "changeModal", { show }: { show: boolean }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { open: boolean; dataKey?: "omnichannel" | "callcenter" }

const form = ref<{ [k: string]: Field }>({});
const loading = ref(false);

const { getComponent, getProps, isHidden } = useFormModal();
// types


// emits


// => Computeds

const schema = computed(() =>
	generateDynamicSchema(Object.values(form.value as any))
);
const error = computed(() => TypificationModalModule.alert);

const edit = computed(() => {
	return TypificationModalModule.type === actionType.edit;
});

// => Methods

function closeModal() {
	TypificationModalModule.setAlert(null);
	emits("changeModal", { show: false });
}
async function onSubmit(e: FormPayload) {
	if (props.dataKey === "omnichannel") TypificationModalModule.setOmniData(e);
	else TypificationModalModule.setData(e);
	TypificationModalModule.setAlert(null);
	emits("changeModal", { show: false });
}
onMounted(async () => {
	if (dynamicForm) {
		const dataForm =
			AppModule.configs.find(c => c.name === "dynamic_typification")?.data ??
			(await dynamicForm);
		form.value = dataForm.reduce((acc, field) => {
			acc[field.name] = field;
			return acc;
		}, {} as { [k: string]: Field });
	}
	const data =
		props.dataKey === "omnichannel"
			? TypificationModalModule.omniData
			: (TypificationModalModule.data as any);
	Object.keys(form.value).forEach(input => {
		form.value[input].value =
			data[input] !== undefined &&
			data[input] !== undefined &&
			data[input] !== ""
				? data[input]
				: undefined;
		form.value[input].disabled = edit.value
			? form.value[input].blockOnEdit
			: false;
	});
});

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.open,
    "show-close": false,
    "modal-classes": "modal-secondary modal-dada",
    "body-classes": "py-0",
    "validate-on-mount": true,
    style: {"animation-duration":"0.3s"},
    "modal-content-classes": "bg-gradient-secondary",
    size: "xl"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        "max-height": "70vh",
        "view-class": "w-100",
        "wrap-class": "w-100"
      }, {
        default: _withCtx(() => [
          (_unref(error))
            ? (_openBlock(), _createBlock(_component_el_alert, {
                key: 0,
                title: _unref(error),
                type: "warning",
                "show-icon": "",
                onClose: _cache[0] || (_cache[0] = () => (error.value = ''))
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(Form), {
            class: "w-100",
            "validation-schema": _unref(schema),
            onSubmit: _cache[1] || (_cache[1] = (e) => onSubmit(e))
          }, {
            default: _withCtx(({ values, setFieldValue }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(form.value), (input, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass({
								'd-none':_unref(isHidden)(input as Field, values, setFieldValue),
								'col-12 col-md-6 col-lg-4': input.type !== 'title',
								'col-12': input.type === 'title'
							}),
                      key: index
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent((_unref(getComponent)(input.type) as any)), _mergeProps({
                        hidden: _unref(isHidden)(input as Field, values, setFieldValue)
                      }, _unref(getProps)(input as Field, values), {
                        name: input.name,
                        type: input.type,
                        label: input.label,
                        placeholder: input.placeholder,
                        size: "sm",
                        "small-label": ""
                      }), null, 16, ["hidden", "name", "type", "label", "placeholder"]))
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_base_button, {
                    type: "link",
                    onClick: closeModal
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_base_button, {
                    loading: loading.value,
                    type: "primary",
                    "native-type": "submit",
                    class: "ml-auto"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})